/**
 * The label shown for a bonus period in pickers. Archived periods get an
 * "(Archived)" tag appended so the status is clear in both the option list and
 * the selected state.
 */
const getBonusPeriodDisplayLabel = (period: {
  label: string;
  status: BonusTypes.PeriodStatus;
}): string =>
  period.status === 'archived' ? `${period.label} (Archived)` : period.label;

export default getBonusPeriodDisplayLabel;
